import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import useMobileLayout from 'Hooks/useMobileLayout';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import YesNoQuestion from 'Components/UI/YesNoQuestion';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '400px',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: theme.spacing(10),
    padding: theme.spacing(2),
  },
  rootDesktop: {
    maxWidth: '600px',
  },
  content: {
    width: '100%',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },
  subtitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },
  yesNoQuestions: {
    paddingTop: theme.spacing(2),
  },
  yesNoQuestion: {
    marginBottom: theme.spacing(2),
  },
});

const Content = ({
  classes,
}) => {
  const {
    resource,
    handleChange,
  } = useMetaLayoutContext();

  const isMobile = useMobileLayout();

  return (
    <div className={classNames(classes.root, {
      [classes.rootDesktop]: !isMobile,
    })}
    >
      {resource.attr('title')
        ? <Title className={classes.title} text={resource.attr('title')} test={'wizard-step-title'} /> : null}
      {resource.attr('subtitle')
        ? <Subtitle className={classes.subtitle} text={resource.attr('subtitle')} test={'wizard-step-subtitle'} /> : null}
      <Box className={classes.content}>
        <MetaFormFields
          className={classes.fields}
          resource={resource}
        />
        <div className={classes.yesNoQuestions}>
          {resource.attr('questions') ? resource.attr('questions').resources().list().map((question, i) => {
            return (
              <YesNoQuestion
                className={classes.yesNoQuestion}
                label={question.attr('title')}
                onChange={(e) => {
                  const array = resource.attr('questions').resources().list();
                  array[i].attr('options', e.target.checked.toString());
                  handleChange('options', resource.attr('questions'));
                }}
                value={question.attr('options') === 'true'}
              />
            );
          }) : null }
        </div>
      </Box>
    </div>
  );
};

Content.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content);
